"use strict";

import { GEOLOCATION } from "../../constants";
import { setLocalStorage } from "../../helpers/localStorage";

const initCurrentCityNotification = () => {
    const $currentCityNotification            = $(".current-city-notification");
    const $closeButtonCurrentCityNotification = $(".js-close-current-city-notification");
    const $openSelectCityButton               = $(".js-open-select-city");

    const $selectCityModal = $(".js-toggle-select-city");
    const $searchCityInput = $selectCityModal.siblings(".js-select-city").find(".js-search-select-city input");

    $closeButtonCurrentCityNotification.on("click", () => {
        $currentCityNotification.attr("hidden", "true");
        setLocalStorage(GEOLOCATION.IS_CITY_NOTIFICATION_DISMISSED, "true");
    });

    $openSelectCityButton.on("click", () => {
        $currentCityNotification.attr("hidden", "true");
        $selectCityModal.toggleClass("open");
        //Automatically focus on the input field, the timeout is necessary because of the animation transition not allowing the element to be focusable
        //Before it finishes
        setTimeout(() => $searchCityInput.trigger("focus"), 500);
        setLocalStorage(GEOLOCATION.IS_CITY_NOTIFICATION_DISMISSED, "true");
    });
};

export default initCurrentCityNotification;
